import $axios from '../backend/vue-axios/axios.js'
const state = {
  showIt: false,
  qc_verify: false,
  map_status: '',
  railData: null
}
const mutations = {
  setShowDisplayState (state, payload) {
    state.showIt = payload
  },
  setQCVerify (state, payload) {
    state.qc_verify = payload
  },
  setRailData (state, payload) {
    state.railData = payload
  },
  resetData (state) {
    state.railData = null
  }
}
const getters = {
  showDisplay (state) {
    return state.showIt
  },
  getRailData (state) {
    return state.railData
  }
}
const actions = {
  toggleDisplay ({commit}, payload) {
    commit('setShowDisplayState', payload)
  },
  async getStation ({commit}, payload) {
    let url = `mapsdata/display/rail_id/${payload.railId}`
    let data = await $axios.get(url)
    commit('resetData')
    commit('setRailData', data.data)
  },
  resetStationData ({ commit }, payload) {
    commit('resetData')
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/showDisplay.js